(() => {
  const AVADA_MESSAGE_PATTERNS = [
    /you\s+must\s+select\s+at\s+least\s+\d+\s+products?\s+in\s+this\s+collection/i,
    /you\s+must\s+select\s+at\s+least\s+\d+\s+items?\s+in\s+this\s+collection/i,
  ];

  const PROTECTED_CART_SELECTOR = [
    'tr',
    'td',
    'tbody',
    'table',
    'cart-items',
    '.js-contents',
    '.cart__items',
    '.cart-item',
    '.cart-item__media',
    '.cart-item__details',
    '.cart-item__title',
    '.cart-item__totals',
    '.cart-item__quantity',
    '.cart-item__price-wrapper',
    '.cart-item__quantity-wrapper',
    '.product-option',
  ].join(', ');

  const PRODUCT_CONTENT_SELECTOR = [
    '.cart-item__name',
    '.cart-item__image-container',
    '.cart-item__price-wrapper',
    '.cart-item__quantity-wrapper',
    '.product-option',
  ].join(', ');

  const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const isAvadaInlineMessage = (value) => {
    const text = normalizeText(value);
    return AVADA_MESSAGE_PATTERNS.some((pattern) => pattern.test(text));
  };

  const patchCartSections = () => {
    const CartItemsElement = customElements.get('cart-items');
    if (!CartItemsElement || CartItemsElement.prototype.__maHawaFooterRefreshPatched) return;

    const originalGetSectionsToRender = CartItemsElement.prototype.getSectionsToRender;
    if (typeof originalGetSectionsToRender !== 'function') return;

    CartItemsElement.prototype.getSectionsToRender = function getSectionsToRenderWithFooterState() {
      const sections = originalGetSectionsToRender.call(this);
      const footer = sections.find((section) => section.id === 'main-cart-footer');
      if (footer) footer.selector = '.cart__blocks';
      return sections;
    };

    CartItemsElement.prototype.__maHawaFooterRefreshPatched = true;
  };

  const addCartLimitStyles = () => {
    if (document.getElementById('MaHawaCartLimitStyles')) return;

    const style = document.createElement('style');
    style.id = 'MaHawaCartLimitStyles';
    style.textContent = `
      [data-ma-hawa-avada-inline-message],
      [data-ma-hawa-minimum-message][hidden] {
        display: none !important;
      }

      [data-ma-hawa-minimum-checkout]:disabled {
        --color-button: 240, 166, 42;
        --color-button-text: 79, 43, 0;
        --alpha-button-background: 1;
        cursor: not-allowed !important;
        opacity: 1 !important;
      }

      [data-ma-hawa-minimum-checkout]:disabled::after {
        box-shadow:
          0 0 0 1px rgba(181, 105, 0, 0.55),
          0 0.8rem 2rem rgba(181, 105, 0, 0.2) !important;
      }

      .ma-hawa-cart-limit-banner {
        align-items: center;
        background:
          linear-gradient(135deg, rgba(255, 250, 235, 0.96), rgba(255, 225, 157, 0.82)),
          rgba(240, 166, 42, 0.16);
        border: 1px solid rgba(181, 105, 0, 0.48);
        border-radius: 1.6rem;
        box-shadow: 0 1rem 3rem rgba(123, 72, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.9);
        color: rgb(79, 43, 0);
        display: grid;
        gap: 1.2rem;
        grid-template-columns: auto minmax(0, 1fr);
        margin: 0 0 1.8rem;
        padding: 1.4rem 1.6rem;
      }

      .ma-hawa-cart-limit-banner[hidden] {
        display: none !important;
      }

      .ma-hawa-cart-limit-banner__icon {
        align-items: center;
        background: rgba(240, 166, 42, 0.2);
        border: 1px solid rgba(181, 105, 0, 0.35);
        border-radius: 999px;
        display: inline-flex;
        flex: 0 0 auto;
        height: 4.2rem;
        justify-content: center;
        width: 4.2rem;
      }

      .ma-hawa-cart-limit-banner__icon svg {
        height: 2rem;
        width: 2rem;
      }

      .ma-hawa-cart-limit-banner__content {
        min-width: 0;
      }

      .ma-hawa-cart-limit-banner__title {
        color: rgb(79, 43, 0);
        font-size: 1.55rem;
        font-weight: 700;
        line-height: 1.35;
        margin: 0;
      }

      .ma-hawa-cart-limit-banner__message {
        color: rgba(79, 43, 0, 0.78);
        display: block;
        font-size: 1.35rem;
        line-height: 1.5;
        margin: 0.25rem 0 0;
      }

      html[dir='rtl'] .ma-hawa-cart-limit-banner {
        direction: rtl;
        text-align: right;
      }

      @media screen and (max-width: 749px) {
        .ma-hawa-cart-limit-banner {
          border-radius: 1.4rem;
          gap: 1rem;
          margin-bottom: 1.4rem;
          padding: 1.2rem 1.3rem;
        }

        .ma-hawa-cart-limit-banner__icon {
          height: 3.8rem;
          width: 3.8rem;
        }

        .ma-hawa-cart-limit-banner__title {
          font-size: 1.45rem;
        }

        .ma-hawa-cart-limit-banner__message {
          font-size: 1.3rem;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const restoreProductContent = (root) => {
    root.querySelectorAll('[data-ma-hawa-avada-inline-message]').forEach((element) => {
      const protectsProductContent =
        element.matches(PROTECTED_CART_SELECTOR) ||
        element.querySelector(PRODUCT_CONTENT_SELECTOR);

      if (!protectsProductContent) return;

      element.removeAttribute('data-ma-hawa-avada-inline-message');
      element.removeAttribute('aria-hidden');
      element.hidden = false;
    });
  };

  const getExactMessageContainer = (textNode, root) => {
    let candidate = textNode.parentElement;
    if (!candidate || candidate === root) return null;
    if (candidate.matches(PROTECTED_CART_SELECTOR)) return null;

    while (candidate.parentElement && candidate.parentElement !== root) {
      const parent = candidate.parentElement;

      if (parent.matches(PROTECTED_CART_SELECTOR)) break;
      if (parent.querySelector(PRODUCT_CONTENT_SELECTOR)) break;

      const parentText = normalizeText(parent.textContent);
      if (!isAvadaInlineMessage(parentText) || parentText.length > 180) break;

      candidate = parent;
    }

    if (candidate.matches(PROTECTED_CART_SELECTOR)) return null;
    if (candidate.querySelector(PRODUCT_CONTENT_SELECTOR)) return null;

    return candidate;
  };

  const hideRepeatedAvadaMessages = () => {
    const root = document.getElementById('main-cart-items');
    if (!root) return;

    restoreProductContent(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const containers = new Set();
    let textNode;

    while ((textNode = walker.nextNode())) {
      if (!isAvadaInlineMessage(textNode.nodeValue)) continue;

      const container = getExactMessageContainer(textNode, root);
      if (container) containers.add(container);
    }

    containers.forEach((container) => {
      container.setAttribute('data-ma-hawa-avada-inline-message', '');
      container.setAttribute('aria-hidden', 'true');
      container.hidden = true;
    });
  };

  const createCartLimitBanner = (titleWrapper) => {
    const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
    const banner = document.createElement('div');
    banner.className = 'ma-hawa-cart-limit-banner';
    banner.setAttribute('data-ma-hawa-cart-limit-banner', '');
    banner.setAttribute('role', 'status');
    banner.setAttribute('aria-live', 'polite');
    banner.innerHTML = `
      <span class="ma-hawa-cart-limit-banner__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
          <path d="M10.29 3.86L2.82 17A2 2 0 004.56 20H19.44A2 2 0 0021.18 17L13.71 3.86A2 2 0 0010.29 3.86Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="ma-hawa-cart-limit-banner__content">
        <strong class="ma-hawa-cart-limit-banner__title">${
          isArabic ? 'الحد الأدنى للطلب: 5 كراتين' : 'Minimum order: 5 cartons'
        }</strong>
        <span class="ma-hawa-cart-limit-banner__message"></span>
      </span>
    `;
    titleWrapper.insertAdjacentElement('afterend', banner);
    return banner;
  };

  const syncMinimumOrderState = () => {
    const cartItems = document.querySelector('cart-items');
    const titleWrapper = cartItems?.querySelector('.title-wrapper-with-link');
    const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    const checkoutButton = cartBlocks?.querySelector('[data-ma-hawa-minimum-checkout]');
    const footerMessage = cartBlocks?.querySelector('[data-ma-hawa-minimum-message]');

    if (!cartItems || !titleWrapper || !cartBlocks || !checkoutButton) return;

    const minimumMet = checkoutButton.disabled === false;
    let banner = cartItems.querySelector('[data-ma-hawa-cart-limit-banner]');

    if (footerMessage) {
      footerMessage.hidden = minimumMet;
      footerMessage.setAttribute('aria-hidden', minimumMet ? 'true' : 'false');
    }

    if (minimumMet) {
      if (banner) {
        banner.hidden = true;
        banner.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (!footerMessage) return;
    if (!banner) banner = createCartLimitBanner(titleWrapper);

    const message = banner.querySelector('.ma-hawa-cart-limit-banner__message');
    if (message) message.textContent = normalizeText(footerMessage.textContent);

    banner.removeAttribute('aria-hidden');
    banner.hidden = false;
  };

  let syncQueued = false;

  const syncCartLimitUi = () => {
    if (syncQueued) return;

    syncQueued = true;
    window.requestAnimationFrame(() => {
      syncQueued = false;
      hideRepeatedAvadaMessages();
      syncMinimumOrderState();
    });
  };

  const scheduleCartLimitSync = () => {
    [0, 100, 300, 700, 1400].forEach((delay) => {
      window.setTimeout(syncCartLimitUi, delay);
    });
  };

  const observeCartLimitUi = () => {
    const itemsRoot = document.getElementById('main-cart-items');
    const footerRoot = document.getElementById('main-cart-footer');
    if (!itemsRoot && !footerRoot) return;

    const observer = new MutationObserver(syncCartLimitUi);

    if (itemsRoot) {
      observer.observe(itemsRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (footerRoot) {
      observer.observe(footerRoot, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    document.addEventListener('input', scheduleCartLimitSync, true);
    document.addEventListener('change', scheduleCartLimitSync, true);
    document.addEventListener('click', (event) => {
      if (event.target.closest('quantity-input, cart-remove-button, [name="updates[]"]')) {
        scheduleCartLimitSync();
      }
    }, true);

    window.addEventListener('pageshow', scheduleCartLimitSync);
    scheduleCartLimitSync();
  };

  addCartLimitStyles();

  customElements.whenDefined('cart-items').then(() => {
    patchCartSections();
    observeCartLimitUi();
  });
})();
